import { JsonObject, JsonProperty } from 'json2typescript';

import { Archive } from './archive';
import { ArchiveNode } from './archive-node';

@JsonObject
export class FolderArchive extends ArchiveNode {

  @JsonProperty('archive', Archive)
  archive: Archive = undefined;

  constructor(archive?: Archive) {
    super();
    this.archive = archive;
  }
}
